import { MutationTree } from "vuex";
import { FriendsState, UnlistenerFunction } from "./types";
import { FriendRef } from "@dokogd/shared";

const SET_LISTENER = "SET_LISTENER";
const SET_FRIENDS_UPDATE = "SET_FRIENDS_UPDATE";

const n = { SET_LISTENER, SET_FRIENDS_UPDATE };

export const mutations: MutationTree<FriendsState> = {
  [n.SET_LISTENER](state, payload: UnlistenerFunction | null) {
    const prevUnlistener = state.unlistener;
    state.friends = [];
    state.unlistener = payload;

    if (prevUnlistener !== null) {
      prevUnlistener();
    }
  },
  [n.SET_FRIENDS_UPDATE](state, payload: FriendRef[]) {
    console.log(n.SET_FRIENDS_UPDATE, payload);
    state.friends = payload;
  },
};

export const mutationNames = n;
